import { useQuery } from '@tanstack/react-query';
import { fetchClassById } from 'src/api/classAPI';
import ApiError from 'src/api/errorHandling/ApiError';
import { fetchSigningFormByClassAndStudent } from 'src/api/signingFormAPI';
import { fetchUserByIdClassId } from 'src/api/userAPI';
import { Class } from 'src/models/classes';
import SigningForm from 'src/models/SigningForm';
import { User } from 'src/models/user';

interface SupervisorAttendancePageState {
  student: User;
  class: Class;
  signingForm: SigningForm | null;
}

export function useSupervisorAttendancePageData(classId: number, studentUserId: number) {
  return useQuery<SupervisorAttendancePageState, ApiError>({
    queryKey: ['useSupervisorAttendancePageData', classId, studentUserId],
    queryFn: async () => {
      const [student, classData] = await Promise.all([
        fetchUserByIdClassId(studentUserId, classId),
        fetchClassById(classId),
      ]);

      let signingForm: SigningForm | null = null;
      try {
        signingForm = await fetchSigningFormByClassAndStudent(classId, studentUserId);
      } catch (error) {
        const apiError = error as ApiError;
        if (apiError.statusCode !== 404) throw apiError;
      }

      return { student, class: classData, signingForm };
    },
  });
}
